// -----------------------------------------------------------------------------
// 業務運用状態 アクション
// -----------------------------------------------------------------------------
import types from './types';

/**
 * 業務運用状態更新
 *
 * @param {Object} status - 業務運用状態
 * @return {Object} アクションオブジェクト
 */
export const updateStatus = (status) => {
  return {
    type: types.UPDATE_STATUS,
    current: status.current,
    coming: status.coming,
  };
};
